import { makeStyles } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "0 auto",
  },

  selected: {
    backgroundColor: theme.orange + " !important",
    color: theme.white,
  },
  nonSelected: {
    color: theme.darkGray,
    backgroundColor: theme.lightGray,
  },
}));

const ProfileToggleBarBase = ({ tabs, value, onChange }) => {
  const classes = useStyles();
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, value) => onChange(value)}
      aria-label="General info type"
      className={classes.container}
    >
      {tabs.map((tab) => {
        return (
          <ToggleButton
            value={tab.title}
            aria-label={tab.title}
            classes={{
              root: classes.nonSelected,
              selected: classes.selected,
            }}
          >
            {tab.title}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default ProfileToggleBarBase;
